import { useState } from "react";

import { type OnChangeFn, type VisibilityState, functionalUpdate } from "@tanstack/react-table";

/* Buzilgan yoki eski formatdagi yozuv butun sahifani yiqitmasligi kerak: o'qib
   bo'lmasa hamma ustun ko'rinadi. Maxfiy rejimda xotiraning o'zi yopiq bo'lishi
   ham mumkin — o'shanda ham jadval standart ustunlar bilan ochiladi. */
const readVisibility = (storageKey: string): VisibilityState => {
  try {
    const saved = localStorage.getItem(storageKey);
    return saved ? (JSON.parse(saved) as VisibilityState) : {};
  } catch {
    return {};
  }
};

/**
 * Ustun ko'rinishi — sahifa yangilanganda ham saqlanib qoladi
 * (brb-workspace'dagi `useColumnVisibility`).
 *
 * Holat jadvalning ichida emas, sahifada turadi va boshlang'ich qiymatini
 * `localStorage` dan BIRINCHI renderdayoq oladi. Yozish faqat odam ustunni
 * almashtirganda sodir bo'ladi — tiklash va yozish o'zaro poyga qilmaydi.
 *
 * Kalit panel prefiksi bilan yoziladi (`learn-up-admin:users`) — bitta
 * domendagi boshqa ilovaning kalitlari bilan to'qnashmasin.
 */
export function useColumnVisibility(storageKey: string) {
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(() =>
    readVisibility(storageKey),
  );

  const onColumnVisibilityChange: OnChangeFn<VisibilityState> = updater => {
    const next = functionalUpdate(updater, columnVisibility);

    try {
      localStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      // Saqlab bo'lmasa ham tanlov shu sessiyada ishlayveradi.
    }
    setColumnVisibility(next);
  };

  return { columnVisibility, onColumnVisibilityChange };
}
